export default __webpack_public_path__ + "static/media/the-playing-one.38564078.png";